module.exports = __webpack_public_path__ + "static/media/Tache.e328468c.svg";